// extracted by mini-css-extract-plugin
module.exports = {"left":"QAEmailPage_left__1ner4","right":"QAEmailPage_right__xH6S5","test":"QAEmailPage_test__19cuJ","status":"QAEmailPage_status__2Ae2h"};